import React, { useCallback } from "react";
import { TextField, BlockStack } from "@medentic/polaris-react";
import useFormattedCurrency from "@shared/hooks/common/useFormattedCurrency";

interface PriceFieldProps {
  value: string;
  onChange: (newValue: string) => void;
  disabled?: boolean;
  label?: string;
  helpText?: string;
  placeholder?: string;
  error?: string;
  requiredIndicator?: boolean;
}

const PriceField: React.FC<PriceFieldProps> = ({
  value,
  onChange,
  disabled = false,
  label,
  helpText,
  placeholder,
  error,
  requiredIndicator,
}) => {
  const { formattedValue, symbol } = useFormattedCurrency({
    value,
  });

  const handleChange = useCallback(
    (newValue: string) => {
      onChange(newValue);
    },
    [onChange]
  );

  return (
    <BlockStack gap="200">
      <TextField
        key={formattedValue}
        prefix={disabled ? undefined : symbol}
        label={label}
        type="text"
        value={disabled ? formattedValue : value}
        onChange={handleChange}
        disabled={disabled}
        helpText={
          helpText + (formattedValue ? " (" + formattedValue + ")" : "")
        }
        placeholder={placeholder}
        autoComplete="off"
        error={error}
        requiredIndicator={requiredIndicator}
        clearButton={true}
        onClearButtonClick={() => {
          onChange("");
        }}
      />
    </BlockStack>
  );
};

export default PriceField;
